/**
 * Filtros locais das listas de Avisos e Campanhas e Liberacoes.
 *
 * As duas listas chegam inteiras da API; a tela filtra, ordena e so entao
 * pagina (pagination.js). Aqui fica so a conta, sem Vue, para o teste rodar
 * em `node --test`.
 *
 * Datas de filtro chegam como `yyyy-MM-dd` de um <input type="date"> e valem
 * o DIA INTEIRO no fuso do navegador: "ate 30/09" inclui 30/09 23:59.
 */

/** Valor de "Responsavel" para as linhas antigas, gravadas sem nome. */
export const NO_OWNER = '-';

const day = (value, endOfDay) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  if (!match) return null;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (endOfDay) date.setHours(23, 59, 59, 999);
  return date.getTime();
};

const time = (value) => {
  if (!value) return null;
  const parsed = new Date(value).getTime();
  return isNaN(parsed) ? null : parsed;
};

/** Criado dentro de [de, ate]; ponta vazia nao limita. */
export const createdWithin = (createdAt, from, to) => {
  const start = day(from, false);
  const end = day(to, true);
  if (start === null && end === null) return true;
  const at = time(createdAt);
  if (at === null) return false;
  return (start === null || at >= start) && (end === null || at <= end);
};

/**
 * Periodo de exibicao ENCOSTA em [de, ate] — "o que esteve no ar nessas
 * semanas". Sem fim, a campanha vale para sempre.
 */
export const overlapsPeriod = (startsAt, endsAt, from, to) => {
  const start = day(from, false);
  const end = day(to, true);
  if (start === null && end === null) return true;
  const itemStart = time(startsAt);
  const itemEnd = time(endsAt);
  if (itemStart === null) return false;
  return (end === null || itemStart <= end) && (start === null || itemEnd === null || itemEnd >= start);
};

/** Nomes distintos de A a Z; NO_OWNER no fim se houver linha sem nome. */
export const ownerOptions = (items) => {
  const names = [];
  let hasNone = false;
  (items || []).forEach((item) => {
    const name = item && item.createdByName;
    if (!name) hasNone = true;
    else if (names.indexOf(name) === -1) names.push(name);
  });
  names.sort((a, b) => a.localeCompare(b, 'pt-BR'));
  const options = names.map((name) => ({ value: name, label: name }));
  if (hasNone) options.push({ value: NO_OWNER, label: 'Sem responsável' });
  return options;
};

export const matchesOwner = (createdByName, owner) => {
  if (!owner) return true;
  if (owner === NO_OWNER) return !createdByName;
  return createdByName === owner;
};

/** Alguma das escolhidas; nenhuma escolhida nao limita. */
export const matchesAny = (values, selected) =>
  !selected || !selected.length || (values || []).some((value) => selected.indexOf(value) !== -1);

/**
 * Filtros <-> query da URL. Lista vira "a,b"; vazio sai da URL, para o link
 * de uma lista sem filtro continuar limpo.
 */
export const toQuery = (filters) => {
  const query = {};
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (Array.isArray(value)) {
      if (value.length) query[key] = value.join(',');
    } else if (value !== '' && value !== null && value !== undefined) {
      query[key] = String(value);
    }
  });
  return query;
};

/** `defaults` diz as chaves e o tipo de cada uma (lista ou texto). */
export const fromQuery = (query, defaults) => {
  const filters = {};
  Object.keys(defaults).forEach((key) => {
    const raw = query && query[key];
    const text = Array.isArray(raw) ? raw[0] : raw;
    if (Array.isArray(defaults[key])) {
      filters[key] = text ? String(text).split(',').filter(Boolean) : [];
    } else {
      filters[key] = text ? String(text) : defaults[key];
    }
  });
  return filters;
};

export const hasAnyFilter = (filters) => Object.keys(toQuery(filters)).length > 0;



// WEBPACK FOOTER //
// ./src/vue/pages/components/default/listFilters.js